export default {
    default: "GTM-M5GJWN6M",
    carculacja: "GTM-KT8ZQ7G",
    vehistools: "GTM-KMXPCRD",
    embed: "GTM-N74DQ2SL"
}
